function dropdown() {
    console.log('dropdown');
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-head');
    const menu = head.querySelector('.gh-head-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-head-logo');
    const navHTML = nav.innerHTML;

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    const makeDropdown = function () {
        customDropDown();
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'nav-more-toggle gh-icon-btn');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        head.classList.add('is-dropdown-loaded');

        window.addEventListener('click', function (e) {
            if (head.classList.contains('is-dropdown-open') && !wrapper.contains(e.target) ) {
                head.classList.remove('is-dropdown-open');
            } else if (toggle.contains(e.target)) {
                head.classList.add('is-dropdown-open');
            }
        });
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            nav.innerHTML = navHTML;
            makeDropdown();
        }, 1);
    });
}

function customDropDown() {

  var dropDown_list = [],
    nav_list = document.querySelectorAll('header .nav li');
  var newMenuList = [];
  var menuTree = {};

  nav_list.forEach( (item, index) => {
    // Ghost >= 6.5x wraps the label in <span class="nav-label"> (and may
    // prepend an <img class="nav-icon">), so test the label's text rather
    // than the anchor's raw innerHTML.
    const link = item.children[0];
    const labelEl = link.querySelector('.nav-label') || link;
    const labelText = labelEl.textContent.trimStart();
    if(labelText[0] == ('-')) {
        labelEl.textContent = labelText.slice(1).trimStart();

      if(menuTree[newMenuList.length - 1]) {
        menuTree[newMenuList.length - 1].push(item);
        
      } else {
        menuTree[newMenuList.length - 1] = [item];
      }
    } else {
      newMenuList.push(item);

    } 
  });

  nav_list = newMenuList.map((item, index) => {
    if(menuTree[index]) {
      let dropdown = document.createElement('ul');
      dropdown.classList.add('ghost-submenu');

      menuTree[index].forEach(child => {
        dropdown.appendChild(child);
        child.classList.add('subitem');
      });

      item.classList.add('menu-item-has-children');
      item.appendChild(dropdown);
    }
    return item;
  });
  let parentsList = document.querySelectorAll('.menu-item-has-children');
  parentsList.forEach(item => {      
      item.children[0].removeAttribute('href');
      item.children[0].addEventListener('click', function() {
        document.querySelectorAll('.menu-item-has-children').forEach(inneritem => {
          if (inneritem != item) {inneritem.classList.remove('active') };
        });
        item.classList.toggle('active')
      });
    });
    // close dropdown when clicked outside
    window.addEventListener('click', function (e) {
        parentsList.forEach(item => {
            if (!item.contains(e.target)) {
                item.classList.remove('active');
            }
        }
        )
    });
/*
  // small screen
  nav_list = document.querySelectorAll('.gh-head .nav li');
    let thistarget=document.querySelector('.gh-head .nav');
  nav_list.forEach( (item, index) => {

      thistarget.appendChild(item);
      if(item.children[0].innerHTML[0] == ('-') && item.previousElementSibling.children[0].innerHTML[0] != ('-')) {
        // parent item needs its link removed
        item.previousElementSibling.children[0].removeAttribute('href')
      } else if (item.children[0].innerHTML[0] != ('-') ) {
        // child item needs its link removed
        item.classList.add('parent-item')
      }
  });

  }
*/
}